import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Card from 'components/card';
import { getLotNumbersTracking } from 'interfaces/stock';
import GoBack from 'components/actions/GoBack';

const TrackLotNumber = () => {
    const nav = useNavigate();
    const params = useParams();
    const [trackings, setTrackings] = useState<any>([]);

    const initTracking = async () => {
        const id = params.id;
        const res = await getLotNumbersTracking(id);
        if (res) {
            setTrackings(res.data);
        }
    };

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            nav('/login');
        }
        initTracking();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id]);

    return (
        <>
            <GoBack />
            <div className="h-full w-full overflow-y-auto">
                {trackings?.productions?.length === 0 &&
                trackings?.orders?.length === 0 &&
                trackings?.products?.length === 0 ? (
                    <div className="mt-10 items-center justify-center h-full">
                        <div className="text-center justify-center">
                            <p className="text-xl font-bold text-gray-600">
                                Aucune information disponible pour ce numéro de
                                lot
                            </p>
                            <button
                                className="mt-5 bg-toola-500 text-white text-sm px-4 py-2 rounded-xl hover:bg-toola-500"
                                onClick={() => nav('/tracking')}
                            >
                                Retour à la recherche
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="sticky top-0 pb-4 z-10">
                        <p className="mt-4 text-center text-gray-600 dark:text-gray-300">
                            Traçabilité
                        </p>
                        <h4 className="mt-2 text-2xl text-center font-bold text-navy-700 dark:text-white">
                            Toutes les informations du lot {params.id}
                        </h4>
                    </div>
                )}

                {/* Productions */}
                <div className="mt-8 space-y-8">
                    {trackings?.productions?.map(
                        (production: any, index: number) => (
                            <div
                                key={`production-${index}`}
                                className=" dark:bg-navy-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3"
                            >
                                <div className="items-center justify-between mb-6 pb-2 border-b border-gray-200 dark:border-gray-700">
                                    <h5 className="text-base font-semibold text-navy-700 dark:text-white">
                                        Production
                                    </h5>
                                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                                        Lot{' '}
                                        <span
                                            className="text-toola-500 underline hover:cursor-pointer"
                                            onClick={() =>
                                                nav(
                                                    `/tracking/${production.lotNumber}`,
                                                )
                                            }
                                        >
                                            {production.lotNumber}
                                        </span>{' '}
                                        le{' '}
                                        {new Date(
                                            production.date,
                                        ).toLocaleDateString()}
                                    </p>
                                </div>

                                <div className="space-y-6">
                                    <div>
                                        <h6 className="text-sm text-navy-700">
                                            Produits utilisés pour produire{' '}
                                            <span className="font-semibold">
                                                {production.quantity}{' '}
                                                {production?.product?.unity}
                                            </span>{' '}
                                            de{' '}
                                            <span className="font-semibold">
                                                {production?.product?.name}{' '}
                                            </span>
                                            ({production?.product?.ref}):
                                        </h6>
                                        <div className="">
                                            {production.ingredients.map(
                                                (
                                                    ingredient: any,
                                                    i: number,
                                                ) => (
                                                    <div
                                                        key={`ingredient-${i}`}
                                                        className="bg-white dark:bg-navy-800 rounded-lg border-gray-200 dark:border-gray-700 p-2"
                                                    >
                                                        <h6 className="text-sm font-semibold text-navy-700 dark:text-white mb-1">
                                                            {ingredient.name}
                                                        </h6>
                                                        <div className="space-y-3">
                                                            {ingredient.movements.map(
                                                                (
                                                                    movement: any,
                                                                    j: number,
                                                                ) => (
                                                                    <div
                                                                        key={`movement-${j}`}
                                                                        className="grid grid-cols-3 gap-4 border rounded-lg p-3"
                                                                    >
                                                                        <div>
                                                                            <p className="text-sm text-gray-600 dark:text-gray-300">
                                                                                Quantité
                                                                            </p>
                                                                            <p className="font-medium text-navy-700 dark:text-white">
                                                                                {
                                                                                    movement.quantity
                                                                                }{' '}
                                                                                {
                                                                                    ingredient.unity
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                        <div>
                                                                            <p className="text-sm text-gray-600 dark:text-gray-300">
                                                                                Zone
                                                                                de
                                                                                stockage
                                                                            </p>
                                                                            <p className="font-medium text-navy-700 dark:text-white">
                                                                                {
                                                                                    movement.area
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                        <div>
                                                                            <p className="text-sm text-gray-600 dark:text-gray-300">
                                                                                Numéro
                                                                                de
                                                                                lot
                                                                            </p>
                                                                            <p
                                                                                className="font-medium text-toola-500 hover:cursor-pointer underline dark:text-white"
                                                                                onClick={() =>
                                                                                    nav(
                                                                                        `/tracking/${movement.lotNumber}`,
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    movement.lotNumber
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ),
                                                            )}
                                                        </div>
                                                    </div>
                                                ),
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                    )}
                </div>
                {/* Orders */}
                <div className="mt-5 space-y-8">
                    {trackings?.orders?.map((order: any, index: number) => (
                        <div
                            key={`order-${index}`}
                            className=" dark:bg-navy-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3"
                        >
                            <div className="items-center justify-between pb-2border-gray-200 dark:border-gray-700">
                                <h5 className="text-base font-semibold text-navy-700 dark:text-white">
                                    Commande{' '}
                                </h5>
                                {order?.products.map(
                                    (product: any, index: number) => (
                                        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                                            - {product.quantity} {product.unity}{' '}
                                            de {product?.name} numéro de lot{' '}
                                            <span
                                                className="text-toola-500 underline hover:cursor-pointer"
                                                onClick={() =>
                                                    nav(
                                                        `/tracking/${product?.lotNumber}`,
                                                    )
                                                }
                                            >
                                                {product?.lotNumber}
                                            </span>{' '}
                                            dans la commande{' '}
                                            <span
                                                className="text-toola-500 underline hover:cursor-pointer"
                                                onClick={() => {
                                                    window.open(
                                                        `/order/${order.id}`,
                                                        '_blank',
                                                    );
                                                }}
                                            >
                                                {order.orderId}
                                            </span>{' '}
                                            livrée le{' '}
                                            {new Date(
                                                order.deliveryDate,
                                            ).toLocaleDateString()}
                                        </p>
                                    ),
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {/* Stock */}
                <div className="mt-5 space-y-8">
                    {trackings?.products?.map((product: any, index: number) => (
                        <div
                            key={`product-${index}`}
                            className=" dark:bg-navy-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3"
                        >
                            <div className="items-center justify-between pb-2border-gray-200 dark:border-gray-700">
                                <h5 className="text-base font-semibold text-navy-700 dark:text-white">
                                    Stock
                                </h5>
                                <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                                    {product.quantity} {product.unity} de{' '}
                                    <span
                                        className="text-toola-500 underline hover:cursor-pointer"
                                        onClick={() =>
                                            window.open(
                                                `/update-product/${product.id}`,
                                                '_blank',
                                            )
                                        }
                                    >
                                        {product?.ref} - {product?.name}
                                    </span>{' '}
                                    avec le numéro de lot{' '}
                                    <span
                                        className="text-toola-500 underline hover:cursor-pointer"
                                        onClick={() =>
                                            nav(
                                                `/tracking/${product.lotNumber}`,
                                            )
                                        }
                                    >
                                        {product.lotNumber}
                                    </span>{' '}
                                    présent dans votre stock
                                    {product.storageArea}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TrackLotNumber;
